<template>
  <v-row>
    <v-col cols="12">
      <!-- <div class="text-right">
        <loading
          :active.sync="isLoading"
          :can-cancel="false"
          loader="dots"
          color="#007bff"
          :height="45"
          :width="75"
          :is-full-page="true"
        ></loading>
      </div> -->
      <div class="tableWrapper">
        <v-data-table
          :headers="headers"
          item-key="retrieval_id"
          :items="dasboardListingData"
          :items-per-page="perpage"
          class="elevation-1"
          hide-default-footer
        >
          <template v-slot:item.import_file_date="{ item }">
            <span class="date-column">{{
              item.import_file_date.split(" ")[0]
            }}</span>
          </template>

          <template v-slot:item.active="{ item }">
            <span style="float: inline-start">{{ item.active }}</span>
            <v-btn
              small
              color="primary"
              class="ms-2"
              @click="removeRecord(item.import_file_id)"
              v-if="item.Action"
            >
              {{ item.Action }}
            </v-btn>
          </template>
        </v-data-table>
        <div class="text-center pt-4 pb-4">
          <Pagination
            :isloading="isLoading"
            :startRecord="startRecord"
            :currentPage="currentPage"
            :lastPage="lastPage"
            :lastRecord="lastRecord"
            :totRecords="totRecords"
            :totPage="totPage"
            :perpage="perpage"
            :isCurrentPageClass="isCurrentPageClass"
            :getLastPageClass="getLastPageClass"
            :getPages="getPages"
            @handlePerPage="handlePerPage"
            @paginate="paginate"
            @last="last"
            @getDataByPage="getDataByPage"
            :showPerPage="showPerPage"
          />
        </div>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import Index from "../Index.vue";
import Buttons from "../component/Buttons.vue";
import Pagination from "../component/Pagination.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import Loading from "vue-loading-overlay";

export default {
  components: { Index, Buttons, Pagination, Loading },
  name: "PanelistReport",
  data: () => ({
    toggleUpdateModal: false,
    options: {},
    sort: "",
    importFile: null,
    editReportMode: false,
    fromDateMenu: false,
    fromDateVal: null,
    isLoading: false,
    fullPage: true,
    allSelected: false,
    perpage: 10,
    dasboardListingData: [],
    selectedRetrievalRecords: [],
    totRecords: "",
    totPage: "",
    currentPage: 1,
    lastPage: "",
    showPerPage: true,
    selectedAlerts: [],
    options: {},
    page: 1,
    alert_data: [],
    pageCount: 0,
    totalReports: 0,
    alertTitle: "",
    alertDesc: "",
    headers: [
      {
        text: "Date",
        value: "import_file_date",
        width: "50px",
        sortable: false,
        class: "v-data-table-header",
      },
      {
        text: "File",
        value: "file",
        width: "100px",
        sortable: false,
        class: "file-width",
      },
      {
        text: "Log",
        width: "250px",
        value: "log",
        sortable: false,
        class: "v-data-table-header",
      },
      {
        text: "User",
        value: "userName",
        sortable: false,
        align: "start",
        width: "150px",
        class: "file-width",
      },
      {
        text: "Active",
        value: "active",
        sortable: false,
        align: "start",
        class: "v-data-table-header",
      },
    ],
  }),
  async mounted() {
    this.getRetrievalMail();
  },
  computed: {
    //pagination computed methods
    startRecord: function () {
      return parseInt(this.lastRecord) - parseInt(this.perpage) + parseInt(1);
    },
    lastRecord: function () {
      return this.perpage * this.currentPage;
    },
    isCurrentPageClass: function () {
      return this.currentPage === 1 ? "" : "notactivespan";
    },
    getLastPageClass: function () {
      return parseInt(this.lastPage) === parseInt(this.currentPage)
        ? ""
        : "notactivespan";
    },

    getPages: function () {
      return this.$utils.getPages(
        this.lastPage,
        this.currentPage,
        this.totPage
      );
    },
  },
  methods: {
    getRetrievalMail() {
      let view = this;
      let dasboardListingUrl = view.$url("DASHBOARD_LISTING");
      const config = { page_number: view.currentPage, page_size: view.perpage };
      
      this.$emit("loaderValue", true);
      try {
        this.$fetch({ requiresAuth: true, operation: "view", vueScope: view })
          .post(dasboardListingUrl, config)
          .then((res) => {
            console.log(res);
            view.dasboardListingData = res.data.data;
            view.page = res.data.pagination.current_page;
            view.perpage = res.data.pagination.page_size;
            view.totRecords = res.data.pagination.total_records;
            view.totPage = parseInt(res.data.pagination.total_pages);
            view.lastPage = Math.ceil(view.totRecords / view.perpage);
      

            this.$emit("loaderValue", false);
          })
          .catch((error) => {
            this.$emit("loaderValue", false);
            this.$swal.fire({
              icon: "error",
              title: "Error",
              text: error,
            });
          });
      } catch (e) {
        this.$emit("loaderValue", false);
        console.log("error", e);
      }
      // view.isLoading = false;
    },

    removeRecord(id) {
      const payload = {
        import_file_id: id,
      };
      let view = this;

      try {
        this.$emit("loaderValue", true);
        this.$fetch({ requiresAuth: true, operation: "edit", vueScope: view })
          .put(view.$url("REMOVE_ENERGYDASHBOARD_FILE"), payload)
          .then((res) => {
            if (res.status == 200) {
              this.$emit("loaderValue", false);
              this.$swal
                .fire({
                  icon: "success",
                  title: "Record Inactivated",
                })
                .then((res) => {
                  console.log(res);
                  if (res.isConfirmed) {
                    this.getRetrievalMail();
                  }
                });
            }
          })
          .catch((error) => {
            this.$emit("loaderValue", false);
            this.$swal.fire({
              icon: "error",
              title: "Error",
              text: error,
            });
          });
      } catch (e) {
        this.$emit("loaderValue", false);
        console.log("error", e);
      }
    },

    getDataByPage(page) {
      let view = this;
      console.log("Data", page);
      this.currentPage = page;
      view.getRetrievalMail();
    },
    handlePerPage(p) {
      console.log("perpage", p);
      let view = this;
      this.$emit('loaderValue',true)

      this.perpage = p;
      this.currentPage = 1;
      this.getRetrievalMail();
    },
    paginate(n) {
      console.log(n);
      this.$emit('loaderValue',true)
      let view = this;
      if (
        parseInt(n) === parseInt(0) &&
        parseInt(this.currentPage) === parseInt(1)
      ) {
        return;
      }
      if (parseInt(n) === parseInt(-1)) {
        if (parseInt(this.currentPage) <= parseInt(1)) {
          return;
        }
      }
      if (parseInt(n) === parseInt(1)) {
        if (parseInt(this.currentPage) >= parseInt(this.lastPage)) {
          return;
        }
      }
      let myPromise = new Promise(function (resolve, reject) {
        resolve(
          (view.currentPage =
            n === 0 ? 1 : parseInt(view.currentPage) + parseInt(n))
        );
        reject("Error: on set page");
      });
      myPromise
        .then(function () {
          view.getRetrievalMail();
        })
        .catch(function (e) {
          console.log(e);
        });
    },
    last() {
      let view = this;
      console.log("last", view.lastPage);
      if (parseInt(view.lastPage) === parseInt(view.currentPage)) {
        return;
      }
      this.currentPage = this.lastPage;
      this.getRetrievalMail();
    },
  },
};
</script>

<style scoped>
.date-column {
  width: 120px;
  display: inline-block;
}

.file-width {
  width: 200px;
  display: inline-block;
}
</style>
